export const CREATE_UPDATE_AGENDA_STARTED = 'CREATE_UPDATE_AGENDA_STARTED';
export const CREATE_UPDATE_AGENDA_COMPLETED = 'CREATE_UPDATE_AGENDA_COMPLETED';
export const CREATE_UPDATE_AGENDA_FAILED = 'CREATE_UPDATE_AGENDA_FAILED';

